module.exports = __webpack_public_path__ + "static/media/Polygon-1.1688aef3.svg";